import { ConfirmModal } from '@/components';
import { useMessage } from '@/providers';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useDeleteOrganizationTemplate } from '../_hooks/organization-template';

type Props = {
  deleteTemplateId: string | null;
  onClose: () => void;
};

export const OrganizationTemplateDeleteModal: FC<Props> = ({
  deleteTemplateId,
  onClose,
}) => {
  const { t } = useTranslation();
  const { openMessage } = useMessage();

  const { mutateAsync: deleteTemplate } = useDeleteOrganizationTemplate();

  return (
    <ConfirmModal
      open={!!deleteTemplateId}
      title={t('delete-confirmation')}
      disclaimerText={t('delete-confirmation-disclaimer')}
      onOk={async () => {
        if (deleteTemplateId) {
          try {
            await deleteTemplate(deleteTemplateId);
            openMessage('success', t('message-delete-completed'));
            onClose();
          } catch {
            await openMessage('error', t('message-delete-failed'));
          }
        }
      }}
      onCancel={onClose}
      skipCheck
    />
  );
};
